import React from 'react';
import { useFormik } from 'formik';
import { useQuery } from 'react-fetching-library';
import { Box, Modal, Card, CardContent, CardHeader, Button, TextField, Portal, IconButton, Stack, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AttachmentIcon from '@mui/icons-material/Attachment';

import RichTextEditor from '../../../../notification/RichTextEditor';

import { getNotificationSettingsDetail } from '../../../../../../services/request';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};


export default function SendMessagePreviewModal ({ handleSend, handleClose, type, fileNames = [], showMessage = false }) {
  const { loading, payload, error } = useQuery(getNotificationSettingsDetail(type));
  const [showRichText, setShowRichText] = React.useState(false);

  const formik = useFormik({
    initialValues: {
      subject: '',
      message: ''
    },
    validateOnChange: false,
    onSubmit: values => {
      values.notification_type = type;
      handleSubmit(values);
    }
  });

  React.useEffect(() => {
    if (!error && !loading) {
      formik.setValues({ 'subject': payload.subject, 'message': payload.message });
      setShowRichText(true);
    }
  }, [loading]);

  const handleSubmit = values => {
    if (formik.values.subject.trim().length !== 0 && formik.values.message.trim().length !== 0) {
      handleSend(values);
    }
  };

  return (
    <Portal>
      <Modal open={true} onClose={handleClose}>
        <Card style={{ ...style, width: 600 }}>
          <CardHeader
            title="Wyślij wiadomość"
            sx={{ textAlign: 'center' }}
            action={
              <IconButton color="primary" onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            }
          />
          <CardContent>
            <TextField
              id="subject"
              fullWidth
              label="temat"
              value={formik.values.subject}
              onChange={formik.handleChange}
            />
            <Box height={20} />
            {(showRichText) ? <RichTextEditor
              text={formik.values.message}
              formik={formik}
              fieldName="message"
              label={null}
              placeholder="treść"
            /> : null}
            { showMessage ? <TextField
              id="message"
              multiline
              rows={8}
              fullWidth
              label="treść"
              value={formik.values.message}
              onChange={formik.handleChange}
            /> : null}
            {fileNames.map((fileName, index) => (
              <React.Fragment key={index}>
                <Box height={20}/>
                <Stack direction="row" spacing={1}>
                  <AttachmentIcon color="primary"/>
                  <Typography variant="subtitle2">{fileName}</Typography>
                </Stack>
              </React.Fragment>
            ))}
            <Box height={20} />
            <Button variant="contained" fullWidth onClick={formik.handleSubmit} disabled={formik.values.subject.trim().length === 0 || formik.values.message.trim().length === 0}>Wyślij</Button>
          </CardContent>
        </Card>
      </Modal>
    </Portal>
  );
};
